/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedContactDealerWrapper_viewer = {
    readonly isMultiRequestModalEnabled: boolean | null;
    readonly " $refType": "SharedContactDealerWrapper_viewer";
};
export type SharedContactDealerWrapper_viewer$data = SharedContactDealerWrapper_viewer;
export type SharedContactDealerWrapper_viewer$key = {
    readonly " $data"?: SharedContactDealerWrapper_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedContactDealerWrapper_viewer",
  "selections": [
    {
      "alias": "isMultiRequestModalEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "multiRequestContactModal"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"multiRequestContactModal\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '044189fc708c66397149b5d34dd200e6';
export default node;
